/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".speech-bubble[_ngcontent-%COMP%]{position:relative}.speech-bubble[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{height:2.2rem}.speech-bubble[_ngcontent-%COMP%]   .bubble[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:#0080ff}.speech-bubble[_ngcontent-%COMP%]   .bubble-content[_ngcontent-%COMP%]{position:absolute;top:0;left:0;right:0;text-align:center;font-family:PoppinsRegular,Arial,Helvetica,sans-serif;font-size:.85rem;font-weight:700;color:#fff;margin-top:.25rem}.speech-bubble[_ngcontent-%COMP%]   .bubble-content.bigger[_ngcontent-%COMP%]{font-size:1rem}"];
export { styles as styles };
//# sourceMappingURL=bubble-popup.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/bubble-popup/bubble-popup.component.scss.shim.ngstyle.js
// module id = 1495
// module chunks = 27 28 29